import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { btnMd, btnPrimary } from '../styles/ui';

const ErrorState = ({ message = 'Something went wrong.', onRetry }) => (
  <div className="bg-white p-8 rounded-3xl border border-emerald-50 shadow-card text-center max-w-lg mx-auto">
    <div className="w-14 h-14 bg-red-50 rounded-xl flex items-center justify-center mx-auto mb-4">
      <AlertTriangle className="text-red-600" size={24} aria-hidden="true" />
    </div>
    <p className="text-ink-secondary mb-4">{message}</p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className={`${btnPrimary} ${btnMd}`}
      >
        Try again
      </button>
    )}
  </div>
);

export default ErrorState;
